/**
 * FAQ Section JavaScript
 * Handles accordion interactions and icon animations
 */

(function() {
  'use strict';

  // Initialize FAQ accordions when DOM is ready
  function initFAQ() {
    const faqSection = document.querySelector('.bannerFaq');
    if (!faqSection) return;

    const detailsElements = faqSection.querySelectorAll('details');
    
    detailsElements.forEach((details) => {
      const summary = details.querySelector('summary.title');
      const icon = summary?.querySelector('.icon');
      
      if (!summary || !icon) return;

      // Handle toggle event for smooth icon rotation
      details.addEventListener('toggle', function() {
        // The CSS handles the rotation, but we can add additional logic here if needed
        if (details.open) {
          icon.setAttribute('aria-expanded', 'true');
        } else {
          icon.setAttribute('aria-expanded', 'false');
        }
      });

      // Set initial aria-expanded state
      if (icon) {
        icon.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }

  // Re-initialize when sections are loaded dynamically (Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initFAQ);
    document.addEventListener('shopify:section:reorder', initFAQ);
  }
})();

